// extracted by mini-css-extract-plugin
module.exports = {"pixSelect":"PixSelectAttributeValue_pixSelect__2nfd2","loadMore":"PixSelectAttributeValue_loadMore__2yYoO"};